import { render, staticRenderFns } from "./locations-filter.vue?vue&type=template&id=5dd65e82"
import script from "./locations-filter.vue?vue&type=script&lang=ts"
export * from "./locations-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports